import React from 'react';
import { OrderStatus } from '../utils';
import DiagonalDivider from 'assets/images/diagonal-divider.png';
import {
  AlertCircle,
  CheckmarkCircle,
  PauseCircleOutline,
} from 'react-ionicons';
import clsx from 'clsx';

const ProgressIndicator = ({
  overallStatus,
  percentage,
}: {
  overallStatus: OrderStatus;
  percentage: number;
}) => {
  if (overallStatus === OrderStatus.NEEDS_ATTENTION)
    return (
      <div className="flex justify-between gap-2 text-red-400">
        <p>Needs attention!</p>{' '}
        <AlertCircle width="20px" height="20px" color="currentColor" />
      </div>
    );
  return (
    <div className="flex w-full items-center gap-2">
      <div
        className={clsx(`relative h-2.5 flex-1 rounded-sm`, {
          'shadow-elevation1':
            overallStatus === OrderStatus.ON_HOLD ||
            overallStatus === OrderStatus.COMPLETE,
        })}
      >
        <div className="absolute h-full w-full rounded-sm bg-neutral-700 bg-opacity-50" />
        <div
          className="h-full w-full rounded-sm bg-auto bg-repeat opacity-[8%]"
          style={{
            backgroundImage: `url(${DiagonalDivider})`,
          }}
        />
        {overallStatus !== OrderStatus.ON_HOLD && (
          <div
            className={clsx(
              'absolute left-0 top-0 h-2.5 rounded-sm shadow-elevation1',
              {
                'bg-green-300': overallStatus !== OrderStatus.COMPLETE,
                'bg-teal-400': overallStatus === OrderStatus.COMPLETE,
              },
            )}
            style={{ width: `${percentage}%` }}
          />
        )}
      </div>
      {overallStatus === OrderStatus.ON_HOLD && (
        <span className="text-content-base-subdued">
          <PauseCircleOutline width="20px" height="20px" color="currentColor" />
        </span>
      )}
      {overallStatus === OrderStatus.COMPLETE && (
        <span className="text-content-accent-default">
          <CheckmarkCircle width="20px" height="20px" color="currentColor" />
        </span>
      )}
    </div>
  );
};

export default ProgressIndicator;
